import * as React from 'react';

import {
  enumSalesItemLineType,
  SalesItemLineType,
} from '@rematter/frontend-lib-api-client';
import capitalize from 'lodash/capitalize';

import { ItemTypeProps } from '../types';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';
import { SelectEnum } from '~/shared/components/select-fields/SelectEnum';

export const ItemTypeFieldCell: React.FC<ItemTypeProps> = ({
  lineItem,
  disabled = false,
  onUpdateLineItem,
}) => {
  const t = useTranslations();

  const handleChangeItemType = React.useCallback(
    (value?: string) => {
      const newType = value as SalesItemLineType;

      onUpdateLineItem(lineItem.id, {
        type: newType,
        aggregatedTags:
          value === enumSalesItemLineType.Raw ? [] : lineItem.aggregatedTags,
      });
    },
    [lineItem.id, lineItem.aggregatedTags, onUpdateLineItem],
  );

  const labelByLineType: Record<SalesItemLineType, string> = React.useMemo(
    () => ({
      [enumSalesItemLineType.Raw]: t.loadsView.form.itemType.loose,
      [enumSalesItemLineType.Tagged]: t.loadsView.form.itemType.tagged,
    }),
    [t],
  );

  const formatOptionLabel = React.useCallback(
    (value: SalesItemLineType) => capitalize(labelByLineType[value]),
    [labelByLineType],
  );

  return (
    <SelectEnum
      enumValue={enumSalesItemLineType}
      formatOptionLabel={formatOptionLabel}
      value={(lineItem.type as SalesItemLineType) || enumSalesItemLineType.Raw}
      onChange={handleChangeItemType}
      isDisabled={disabled}
      className="@ItemTypeFieldCell"
    />
  );
};
